import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { VisibilityOffOutlined as ImageHiddenIcon } from '@mui/icons-material';

const StyledOverlay = styled('div')(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(15px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    '.MuiSvgIcon-root': {
      width: 24,
      height: 24,
      color: 'rgba(255, 255, 255, 0.6)',
    },
  },
  addHighContrastStyles({
    '.MuiSvgIcon-root': {
      padding: 4,
      color: 'white',
      backgroundColor: 'black',
      borderRadius: 4,
    },
  }),
);

const ThumbnailInappropriateContentOverlay = () => (
  <StyledOverlay>
    <ImageHiddenIcon />
  </StyledOverlay>
);

export default ThumbnailInappropriateContentOverlay;
